import formatDate from "../util/dateFormat";
import DefaultImage from "../assets/SuntecNewLogo.png";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { columns, metaData } from "../static-models/ListReceiptData";
import useButtonStyles from "../styles/useButtonStyles";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import axios from "axios";
import { APIConstants, APIModuleConstants } from "../constants/ApiConstants";
import { useDispatch } from "react-redux";
import { receiptsActions } from "../redux/slices/recieptsSlice";
import { useAppSelector } from "../redux/hooks";
import { getFeaturePermissions } from "../util/permissions";
import exportFromJSON from "export-from-json";
import { useListReceipts } from "../Hooks/receipts/useListReceipts";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import AddReceipt from "./AddReceipt";
import FraudDetectSettings from "./FraudDetectSetting";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import UpdateMemberReceipts from "../components/member/UpdateMemberReceipts";
import { getHashURL } from "../util/SearchandFIlters/searchAndFilter";
import { operatorConstants } from "../util/SearchandFIlters/Constants";
import InputProps, { DualInputProps } from "./SharedContents/InputProps";
import InfiniteTable from "../components/Table/InfiniteScroll/InfiniteTable";
import useGetTotalRecords from "../Hooks/CustomHooks/UseGetTotalRecords";
import { getReceipts } from "../services/ApiServices/Receipts";
import {
  SearchToolTip,
  filterConstants,
  hashKey,
  hashValue,
  DateConstants,
  modelName,
} from "../constants/AppConstants";
import SearchInput from "../Shared/Components/SearchInput/SearchInput";
import ExportDialog from "../Shared/Components/ExportDialog/ExportDialog";
import { exportData } from ".././services/ApiServices/export";
import { getEncodedValue } from "../components/forms/utility";
import { usePermissionGetter } from "../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../Shared/Components/Buttons/CommonButton";
import useDateFilter from "../Hooks/Filters/useDateFilter";
export interface TableColumn {
  key: string;
  header: string;
  searchable?: boolean;
  filterable?: boolean;
  dropdownOptions?: string[];
  isCheckbox?: boolean;
}

const ListReceipt = () => {
  const [tab, setTab] = React.useState("receipt");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTab(newValue);
  };
  const { getUserPermission: getReceiptPermission } = usePermissionGetter(
    "receipts",
    "receipts",
  );
  const { getUserPermission: getAuditTrailPermission } = usePermissionGetter(
    "receipts",
    "audit_trails",
  );
  const { getUserPermission: getFraudDetectPermission } = usePermissionGetter(
    "receipts",
    "fraud_detect_configuration",
  );

  const { fetchFraudSettings } = useListReceipts();
  const auditModeKey = "auditMode";
  const initialAuditMode = localStorage.getItem(auditModeKey) === "true";
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions,
  );
  const fraudSettings = useAppSelector(
    (state: any) => state.persistReducers.getReceiptsList.fraudSettings,
  );
  const receiptsList = useAppSelector(
    (state: any) => state.persistReducers.getReceiptsList?.receiptsList,
  );
  const receiptsRandomList = useAppSelector(
    (state: any) => state.persistReducers.getReceiptsList?.receiptsRandomList,
  );

  const [data, setData] = useState<any>([]);
  const [randomData, setRandomData] = useState<any>([]);
  const [filterActive, setFilterActive] = useState(false);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [loadingAPI, setLoadingAPI] = useState<boolean>(false);
  const [errorAPI, setErrorAPI] = useState<boolean>(false);
  const [exportEmail, setExportEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [isRandomAudit, setIsRandomAudit] = useState(initialAuditMode);

  const [openFilter, setOpenFilter] = useState(false);
  const dispatch = useDispatch();

  const theme = useTheme();
  const buttonStyles = useButtonStyles();

  const [nextPageKey, setNextPageKey] = useState<any>(null);
  const [apiFromKey, setApiFromKey] = useState<Number>(0);
  const [totalDataCount, setTotalDataCount] = useState<Number>(0);
  const [statusFilter, setStatusFilter] = useState("");
  const [memberIdSearch, setMemberIdSearch] = useState("");
  const currentDate = new Date();
  currentDate.setDate(currentDate.getDate() + 1);
  const pastDate = new Date();
  pastDate.setDate(currentDate.getDate() - 15);
  const fromDate = `${pastDate.getFullYear()}-${(pastDate.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${pastDate.getDate()}`;
  const toDate = `${currentDate.getFullYear()}-${
    currentDate.getMonth() + 1
  }-${currentDate.getDate()}`;
  const [dateFilter, setDateFilter] = useState({
    fromDate,
    toDate,
    filterKey: "",
  });
  const [email, setEmail] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);
  const [exportText, setExportText] = useState("");
  const [visited, setVisited] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [selectState, setSelectState] = useState<any>("");
  const [clear, setClear] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(10);
  const [openAddReceipt, setOpenAddReceipt] = useState(false);
  const [openFraudSettings, setOpenFraudSettings] = useState(false);
  const [openUpdateReceipt, setOpenUpdateReceipt] = useState(false);
  const [receipt, setReceipt] = useState<any>({});
  const [popupContent, setPopupContent] = useState<ReactElement>(<></>);
  const [filterAmount, setFilterAmount] = useState({});
  const amountFrom = useRef<HTMLInputElement>(null);
  const amountTo = useRef<HTMLInputElement>(null);
  const adjustedAmountFrom = useRef<HTMLInputElement>(null);
  const adjustedAmountTo = useRef<HTMLInputElement>(null);
  const searchInputRef = useRef<HTMLInputElement>();
  const inputCompRef = useRef<any>({});
  const [updatedAmntInput, setUpdatedAmntInput] = useState({});
  const [isApiCall, setIsApiCall] = useState(true);
  const [canAddMoreData, setAddMoreData] = useState(false);

  const [selectedOption, setSelectedOption] = useState("");
  const [selectedReceiptType, setSelectedReceiptType] = useState("");
  const navigate = useNavigate();
  const { totalCount, getTotalCounts, getTotalRecordsCount } =
    useGetTotalRecords();

  const [commonFilterValue, setCommonFilterValue] = useState<any>();

  const params = useParams();
  const { receiptsId } = params;

  const entityConstants = {
    amount_from: "amount_from",
    amount_to: "ammount_to",
    adjust_from: "adjusted_from",
    adjust_to: "adjust_to",
    createdAt: "createdAt",
    reviewed_date: "reviewed_date",
    date_of_purchase: "date_of_purchase",
  };

  const { selectedDates, onUpdateFiltedDate, onResetDate, valueWithOperator } =
    useDateFilter([entityConstants.createdAt]);
  const dropdownOptions = [
    { id: filterConstants.Accept.toLowerCase(), label: filterConstants.Accept },
    { id: filterConstants.Reject.toLowerCase(), label: filterConstants.Reject },
    {
      id: filterConstants.Pending.toLowerCase(),
      label: filterConstants.Pending,
    },
    {
      id: filterConstants.Processing.toLowerCase(),
      label: filterConstants.Processing,
    },
    {
      id: filterConstants.Appeal.toLowerCase(),
      label: filterConstants.Appeal,
    },
  ];
  const receiptTypeOptions = [
    { id: "Physical receipt", label: "Physical receipt" },
    { id: "SOUNDBOX", label: "SOUNDBOX" },
    { id: "Member uploaded receipts", label: "Member uploaded receipts" },
  ];
  useEffect(() => {
    if (isApiCall) bindSearchAndFilter();
  }, [isApiCall]);

  useEffect(() => {
    if (receiptsId) {
      const singleReceipt = receiptsList.filter(
        (receipt: any) => receipt.id === receiptsId,
      );
      const receipt = singleReceipt[0];
      setReceipt(receipt);
      setOpenUpdateReceipt(true);
    }
  }, [receiptsId]);

  const getRandomAudit = async (urlToConact: any) => {
    try {
      const randomAuditResponse = await axios.get(
        process.env.REACT_APP_API_URL +
          APIConstants.randomAudit +
          "?" +
          urlToConact,
      );
      setLoadingAPI(false);
      getTotalRecordsCount(APIModuleConstants.receipt);

      const mappedAuditData = randomAuditResponse.data.value.map(
        (item: any, index: any) => {
          // Calculate evoucher amount and code if eVouchers array has items and receipt type is SOUNDBOX
          let evoucherAmount = "-";
          let evoucherCode = "-";
          if (
            item.receipt_type === "SOUNDBOX" &&
            item.eVouchers &&
            item.eVouchers.length > 0
          ) {
            const totalEvoucherValue = item.eVouchers.reduce(
              (sum: number, voucher: any) => {
                const voucherValue = parseFloat(voucher.value) || 0;
                return sum + voucherValue;
              },
              0,
            );
            evoucherAmount =
              totalEvoucherValue > 0 ? `S$ ${totalEvoucherValue}` : "-";

            // Get evoucher codes (comma-separated if multiple)
            const codes = item.eVouchers
              .map((voucher: any) => voucher.code)
              .filter((code: any) => code);
            evoucherCode = codes.length > 0 ? codes.join(", ") : "-";
          }

          // Calculate physical voucher amount and code if physicalVouchers array has items and receipt type is SOUNDBOX
          let physicalVoucherAmount = "-";
          let physicalVoucherCode = "-";
          if (
            item.receipt_type === "SOUNDBOX" &&
            item.physicalVouchers &&
            item.physicalVouchers.length > 0
          ) {
            const totalPhysicalVoucherValue = item.physicalVouchers.reduce(
              (sum: number, voucher: any) => {
                const voucherValue = parseFloat(voucher.value) || 0;
                return sum + voucherValue;
              },
              0,
            );
            physicalVoucherAmount =
              totalPhysicalVoucherValue > 0
                ? `S$ ${totalPhysicalVoucherValue}`
                : "-";

            // Get physical voucher codes (comma-separated if multiple)
            const codes = item.physicalVouchers
              .map((voucher: any) => voucher.code)
              .filter((code: any) => code);
            physicalVoucherCode = codes.length > 0 ? codes.join(", ") : "-";
          }

          return {
            memberName: item.member_name ? item.member_name : "-",
            image: item.upload_log[0].receipt_image,
            loyaltyCardNo:
              item.loyalty_card_no === "" ? "-" : item.loyalty_card_no,
            reviewed_by: item.reviewed_by ? item.reviewed_by : "-",
            amountBpo: `S$ ${item.amount_bpo}`,
            amountMember:
              item.receipt_type.toLowerCase() == "soundbox"
                ? `S$ ${item.amount_member != null ? item.amount_member : 0}`
                : item.amount_member
                  ? `S$ ${item.amount_member}`
                  : "-",
            paymentType: item.payment_type ? item.payment_type : "-",
            submissionDate: formatDate(item.submission_date),
            receiptDate: item.date_of_purchase
              ? item.date_of_purchase === "1970-01-01T00:00:00.000Z"
                ? "-"
                : formatDate(item.date_of_purchase)
              : "-",
            reviewedDate:
              item.reviewed_date === "1970-01-01T00:00:00.000Z"
                ? "-"
                : formatDate(item.reviewed_date),
            rejectionDate:
              item.upload_log.filter(
                (log: any) =>
                  log.status === filterConstants.Reject.toLowerCase(),
              ).length === 0
                ? "-"
                : formatDate(
                    item.upload_log.filter(
                      (log: any) =>
                        log.status === filterConstants.Reject.toLowerCase(),
                    )[0].upload_time,
                  ),
            tallyCheck: item.tally_check ? "Ok" : "Not Ok",
            tallyCheckMessage:
              item.tally_check_message === "" ? "-" : item.tally_check_message,
            status: item.receipt_status,
            receiptType: item.receipt_type,
            remark: item.remarks,
            receiptNumber: item.receipt_number,
            merchantName: item.merchant_name,
            id: item.id ? item.id : "-",
            navigateTo: item.id ? `/receipts/${item.id}` : "-",
            yuuAmount: item?.yuu_included_amount
              ? `S$ ${item?.yuu_included_amount}`
              : item?.yuu_included_amount === 0
                ? `S$ ${0}`
                : "-",
            evoucherAmount: evoucherAmount,
            evoucherCode: evoucherCode,
            physicalVoucherAmount: physicalVoucherAmount,
            physicalVoucherCode: physicalVoucherCode,
            points: item.points != null ? item.points : "-",
            // navigateTo:
            //   item.id &&
            //   getFeaturePermissions(permissions, "Receipt", "Member Receipts")
            //     .update
            //     ? `${"/updateMemberReceipts/"}${item.id}`
            //     : null,
          };
        },
      );

      dispatch(
        receiptsActions.updateReceiptsListRandom({
          receiptsRandomList: mappedAuditData,
        }),
      );
      setTotalDataCount(mappedAuditData?.length);
      setRandomData(mappedAuditData);
    } catch (error) {
      setLoadingAPI(false);
    } finally {
      setIsApiCall(false);
    }
  };
  const handleExportCSV = () => {
    const exportableData = filteredData || receiptsList;

    if (exportableData.length > 0) {
      const options = {
        headers: Object.keys(exportableData[0]),
      };
      const fileName = "filtered_data.csv";
      exportFromJSON({ data: exportableData, fileName, exportType: "csv" });
    } else {
      console.error("No data to export");
    }
  };

  const handleStatusFilterChange = (value: string) => {
    setStatusFilter(value);
  };

  const handleMemberIdSearchChange = (value: string) => {
    setMemberIdSearch(value);
  };
  const handleFromDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDateFilter({ ...dateFilter, fromDate: event.target.value });
  };

  const handleToDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDateFilter({ ...dateFilter, toDate: event.target.value });
  };

  const [updatedDateFilter, setupdatedDateFilter] = useState({});
  const [updatedAmountFilter, setupdatedAmountFilter] = useState({});
  const [updatedAdjustedAmount, setupdatedAdjustedAmount] = useState({});
  const getDateType = (type: string) => {
    switch (type) {
      case "":
        return "last_updated";
      case "Last Updated Receipt":
        return "last_updated";
      case "Submission Date":
        return "submission_date";
      case "Rejection Date":
        return "rejection_date";
      case "Review Date":
        return "reviewed_date";
    }
  };

  const onInputAmntChange = (filedName: string, value: any) => {
    setUpdatedAmntInput((prev) => ({
      ...prev,
      [filedName]: value,
    }));
  };
  const onInputAdjustedAmntChange = (filedName: string, value: any) => {
    setupdatedAdjustedAmount((prev) => ({
      ...prev,
      [filedName]: value,
    }));
  };
  const onInputChange = (filedName: string, value: any, states: any) => {
    states((prevState: any) => ({
      ...prevState,
      [filedName]: value,
    }));
  };

  const getInputValue = (fieldItem: any, state: any) => {
    const item = state[fieldItem as keyof typeof state];
    return item !== undefined ? item : "";
  };
  const getAmntInputValue = (fieldName: any) => {
    const item = updatedAmntInput[fieldName as keyof typeof updatedAmntInput];
    return item !== undefined ? item : "";
  };
  const getAdjustedAmntInputValue = (fieldName: any) => {
    const item =
      updatedAdjustedAmount[fieldName as keyof typeof updatedAdjustedAmount];
    return item !== undefined ? item : "";
  };

  const formatData = (list: any[]) => {
    return list.map((data: any) => {
      const item = data._source;

      // Calculate evoucher amount and code if eVouchers array has items and receipt type is SOUNDBOX
      let evoucherAmount = "-";
      let evoucherCode = "-";
      if (
        item.receipt_type === "SOUNDBOX" &&
        item.eVouchers &&
        item.eVouchers.length > 0
      ) {
        const totalEvoucherValue = item.eVouchers.reduce(
          (sum: number, voucher: any) => {
            const voucherValue = parseFloat(voucher.value) || 0;
            return sum + voucherValue;
          },
          0,
        );
        evoucherAmount =
          totalEvoucherValue > 0 ? `S$ ${totalEvoucherValue}` : "-";

        // Get evoucher codes (comma-separated if multiple)
        const codes = item.eVouchers
          .map((voucher: any) => voucher.code)
          .filter((code: any) => code);
        evoucherCode = codes.length > 0 ? codes.join(", ") : "-";
      }

      // Calculate physical voucher amount and code if physicalVouchers array has items and receipt type is SOUNDBOX
      let physicalVoucherAmount = "-";
      let physicalVoucherCode = "-";
      if (
        item.receipt_type === "SOUNDBOX" &&
        item.physicalVouchers &&
        item.physicalVouchers.length > 0
      ) {
        const totalPhysicalVoucherValue = item.physicalVouchers.reduce(
          (sum: number, voucher: any) => {
            const voucherValue = parseFloat(voucher.value) || 0;
            return sum + voucherValue;
          },
          0,
        );
        physicalVoucherAmount =
          totalPhysicalVoucherValue > 0
            ? `S$ ${totalPhysicalVoucherValue}`
            : "-";

        // Get physical voucher codes (comma-separated if multiple)
        const codes = item.physicalVouchers
          .map((voucher: any) => voucher.code)
          .filter((code: any) => code);
        physicalVoucherCode = codes.length > 0 ? codes.join(", ") : "-";
      }

      const uploadLogs = Array.isArray(item.upload_log) ? item.upload_log : [];
      const isSoundbox = item.receipt_type?.toLowerCase() === "soundbox";
      const latestUploadLog = isSoundbox
        ? [...uploadLogs].sort(
            (a: any, b: any) =>
              new Date(b?.upload_time).getTime() -
              new Date(a?.upload_time).getTime(),
          )[0]
        : uploadLogs[0];
      const latestReceiptImage = latestUploadLog
        ? latestUploadLog.receipt_image
        : "";
      const receiptImage =
        isSoundbox && (!latestReceiptImage || latestReceiptImage === "null")
          ? DefaultImage
          : latestReceiptImage;

      return {
        memberName: item.member_name ? item.member_name : "-",
        image: receiptImage,
        loyaltyCardNo: item.loyalty_card_no === "" ? "-" : item.loyalty_card_no,
        reviewed_by: item.reviewed_by ? item.reviewed_by : "-",
        amountBpo:
          item.receipt_type.toLowerCase() == "soundbox"
            ? `S$ ${item.amount_bpo != null ? item.amount_bpo : 0}`
            : item.amount_bpo
              ? `S$ ${item.amount_bpo}`
              : "-",
        amountMember:
          item.receipt_type.toLowerCase() == "soundbox"
            ? `S$ ${item.amount_member != null ? item.amount_member : 0}`
            : item.amount_member
              ? `S$ ${item.amount_member}`
              : "-",
        paymentType: item.payment_type ? item.payment_type : "-",
        submissionDate: item.submission_date
          ? formatDate(item.submission_date)
          : "-",
        reviewedDate: item.reviewed_date
          ? item.reviewed_date === "1970-01-01T00:00:00.000Z"
            ? "-"
            : formatDate(item.reviewed_date)
          : "-",
        receiptDate: item.date_of_purchase
          ? item.date_of_purchase === "1970-01-01T00:00:00.000Z"
            ? "-"
            : formatDate(item.date_of_purchase)
          : "-",
        rejectionDate: item.upload_log
          ? item.upload_log.some(
              (log: any) => log.status === filterConstants.Reject.toLowerCase(),
            )
            ? formatDate(
                item.upload_log.find(
                  (log: any) =>
                    log.status === filterConstants.Reject.toLowerCase(),
                ).upload_time,
              )
            : "-"
          : "-",

        tallyCheck: item.tally_check
          ? item.tally_check
            ? "Ok"
            : "Not Ok"
          : "-",
        tallyCheckMessage: item.tally_check_message
          ? item.tally_check_message === ""
            ? "-"
            : item.tally_check_message
          : "-",
        status: item.receipt_status ? item.receipt_status : "-",
        receiptType: item.receipt_type ? item.receipt_type : "-",
        remark: item.remarks ? item.remarks : "-",
        receiptNumber: item.receipt_number ? item.receipt_number : "-",
        merchantName: item.merchant_name ? item.merchant_name : "-",
        id: item.id ? item.id : "-",
        navigateTo: item.id ? `/receipts/${item.id}` : "-",
        yuuAmount: item?.yuu_included_amount
          ? `S$ ${item?.yuu_included_amount}`
          : item?.yuu_included_amount === 0
            ? `S$ ${0}`
            : "-",
        evoucherAmount: evoucherAmount,
        evoucherCode: evoucherCode,
        physicalVoucherAmount: physicalVoucherAmount,
        physicalVoucherCode: physicalVoucherCode,
        points: item.points != null ? item.points : "-",
      };
    });
  };

  const fetchReceipt = async (queryUrl: string) => {
    try {
      setLoadingAPI(true);
      //v2 integration
      let urlToConact = `fromKey=${apiFromKey}`;

      if (queryUrl) urlToConact += `&${queryUrl}`;
      // if (data.length === 0)
      //   getTotalRecordsCount(APIModuleConstants.receipt, queryUrl);
      if (nextPageKey) {
        urlToConact += `&lastKey=${encodeURIComponent(
          JSON.stringify(nextPageKey),
        )}`;
      }
      urlToConact += `&module=receipts&feature=receipts`;
      const response = await getReceipts(urlToConact);
      const { lastKey, result, fromKey, totalCount } = response;
      const receipts = formatData(result);
      setApiFromKey(fromKey);
      const keytoSet = lastKey ? lastKey : null;
      setNextPageKey(keytoSet);
      setTotalDataCount(totalCount);
      const dataToSet = canAddMoreData ? [...data, ...receipts] : receipts;
      dispatch(
        receiptsActions.updateReceiptsList({
          receiptsList: dataToSet,
        }),
      );
      setData(dataToSet);
      setLoadingAPI(false);
    } catch (msg) {
      setLoadingAPI(false);
    } finally {
      setAddMoreData(false);
      setIsApiCall(false);
    }
  };

  const handleSearch = () => {
    onBind();
  };

  const handleReset = () => {
    setClear(true);
    setStatusFilter("");
    onResetDate();
    setMemberIdSearch("");
    setDateFilter({ fromDate: "", toDate: "", filterKey: "" });
    setFilteredData(null);
    setNextPageKey(null);
    setApiFromKey(0);
    setRandomData([]);
    setTotalDataCount(0);
    setData([]);
  };

  const handleExport = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setExportEmail(e.target.value);
    isValidEmail(e.target.value);
  };

  const formatCSVData = (filteredData: any) => {
    return filteredData?.map((csvRow: any) => {
      const rowWithoutNavigateTo = { ...csvRow };
      delete rowWithoutNavigateTo.navigateTo;
      return rowWithoutNavigateTo;
    });
  };

  const toggleAudit = async () => {
    setIsRandomAudit((prevState) => !prevState);
    localStorage.setItem(auditModeKey, String(!isRandomAudit));
    setApiFromKey(0);
    setRandomData([]);
    setTotalDataCount(0);
    setData([]);
    // handleReset();
    if (!isRandomAudit) {
      setLoadingAPI(true);

      let urlToConact = `limit=50&fromKey=0&placeholderId=ALL-RECORDS`;
      if (commonFilterValue) urlToConact += `&filters=${commonFilterValue}`;
      urlToConact += `&module=receipts&feature=receipts`;
      getRandomAudit(urlToConact);
    } else {
      setLoadingAPI(true);
      setIsApiCall(true);
    }
  };

  useEffect(() => {
    receiptsList.length > 0 ? setLoadingAPI(false) : setLoadingAPI(true);
    fetchFraudSettings();
    // bindSearchAndFilter()
    // fetchData();
    // fetchReceiptByDate();

    return () => {
      localStorage.setItem(auditModeKey, String(false));
    };
  }, []);

  const fetchDataWrapper = async () => {
    setLoadingAPI(true);

    if (isRandomAudit) {
      await getRandomAudit("");
    }

    setLoadingAPI(false);
  };
  const isValidEmail = (email: any) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (emailRegex.test(email)) {
      setValidEmail(true);
    } else {
      setValidEmail(false);
    }
  };

  const getFilterDates = () => {
    const data = Object.keys(updatedDateFilter).map((item: any) => {
      return {
        fieldValue: item,
        value: new Date(
          updatedDateFilter[item as keyof typeof updatedDateFilter],
        )
          .getTime()
          .toString(),
        operator: operatorConstants.equal,
      };
    });
    return data;
  };
  const getFilterStatus = () => {
    const statusParam = [];
    if (selectedOption !== "")
      statusParam.push({
        fieldValue: "receipt_status",
        value: selectedOption,
        operator: operatorConstants.equal,
      });
    return statusParam;
  };
  const getFilterReceiptType = () => {
    const receiptTypeParam = [];
    if (selectedReceiptType !== "")
      receiptTypeParam.push({
        fieldValue: "receipt_type",
        value: selectedReceiptType,
        operator: operatorConstants.equal,
      });
    return receiptTypeParam;
  };
  const getFilterAmount = () => {
    const amntData = Object.keys(updatedAmntInput)
      .filter(
        (key) =>
          key && updatedAmntInput[key as keyof typeof updatedAmntInput] !== "",
      )
      .map((key) => updatedAmntInput[key as keyof typeof updatedAmntInput]);

    const adjustedSAmnt = Object.keys(updatedAdjustedAmount)
      .filter(
        (key) =>
          key &&
          updatedAdjustedAmount[key as keyof typeof updatedAdjustedAmount] !==
            "",
      )
      .map(
        (key) =>
          updatedAdjustedAmount[key as keyof typeof updatedAdjustedAmount],
      );

    const filterValue = {
      fieldValue: "amount_member",
      value: amntData,
      operator: operatorConstants.between,
    };
    const adjustedValue = {
      fieldValue: "amount_bpo",
      value: adjustedSAmnt,
      operator: operatorConstants.between,
    };
    const amnt_val = [];
    if (amntData.length > 1) {
      amnt_val.push(filterValue);
    }
    if (adjustedSAmnt.length > 1) {
      amnt_val.push(adjustedValue);
    }
    return amnt_val;
  };
  const getFilterValues = () => {
    const filterDateParam = getFilterDates();
    const filterStatus = getFilterStatus();
    const filterReceiptType = getFilterReceiptType();
    const filterAmount = getFilterAmount();
    const filterParam = [
      ...filterDateParam,
      ...filterAmount,
      ...filterStatus,
      ...filterReceiptType,
      ...valueWithOperator,
    ];
    return filterParam;
  };

  const handleApplyFilter = () => {
    setOpenFilter(false);
    onBind();
  };

  const onBind = (canAddExtraData?: boolean) => {
    setAddMoreData(Boolean(canAddExtraData));
    if (!canAddExtraData) {
      setRandomData([]);
      setData([]);
      setNextPageKey(null);
      setApiFromKey(0);
      setTotalDataCount(0);
    }
    setIsApiCall(true);
  };
  const bindSearchAndFilter = () => {
    const url = getFilterParams();
    const searchParams = new URLSearchParams(url);
    const filtersValue = searchParams.get("filters");

    filtersValue && setFilterActive(true);
    setCommonFilterValue(filtersValue);
    fetchReceipt(url);
  };
  const getFilterParams = () => {
    const hashValues = { field: "placeholderId", value: "ALL-RECORDS" };
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const searchParam = searchValue !== "" ? [searchValue] : [];
    const filterItems = getFilterValues();
    const params = {
      hashData: hashValues,
      filterData: filterItems,
      searchData: searchParam,
    };
    const url = getHashURL(params);
    return url;
  };
  const closeDrawer = () => {
    setOpenUpdateReceipt(false);
    navigate("/receipts");
  };

  const resetFilterState = () => {
    setUpdatedAmntInput({});
    setupdatedDateFilter({});
    setupdatedAmountFilter({});
    setupdatedAdjustedAmount({});
    setSelectedOption("");
    setSelectedReceiptType("");
    onBind();
    onResetDate();
    setFilterActive(false);
  };

  const handleOnCloseFilter = () => {
    // if (!isFilterApplied) resetFilterState();
    setOpenFilter(false);
  };

  const handleSendExport = async () => {
    const getFP = getFilterParams();
    setSending(true);
    const handleExportFun = await exportData(
      getFP,
      modelName.receiptSuntec,
      hashKey.placeholderId,
      hashValue.allRecords,
    );
    handleExportFun.data.status === true && setEmailSent(true);
    setSending(false);
    setTimeout(() => {
      setEmailSent(false);
    }, 3000);
  };

  const displayAuditTrails = () => {
    return isRandomAudit ? (
      <CommonButton
        buttonTitle="Normal-Audit"
        variant="text"
        color="secondary"
        onClick={toggleAudit}
      />
    ) : (
      <CommonButton
        buttonTitle="Audit Trails"
        variant="text"
        color="secondary"
        onClick={toggleAudit}
      />
    );
  };

  return (
    <Grid
      sx={{ background: theme.color?.background }}
      borderRadius={"16px"}
      overflow={"hidden"}
    >
      <Dialog onClose={handleCloseFilter} open={openFilter} sx={{ ml: "60vw" }}>
        <Grid sx={{ width: "484px", py: 4, px: 2 }}>
          <DialogTitle
            display={"flex"}
            justifyContent={"space-between"}
            borderBottom={theme.border?.smallGrey}
          >
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                color: theme.color?.primary,
                fontSize: theme.font?.fontSize.large,
                fontWeight: theme.font?.fontWeight.thicker,
              }}
            >
              Filter
            </Typography>
            {/* <IconButton onClick={() => setOpenFilter(false)}> */}
            <IconButton onClick={handleOnCloseFilter}>
              <CloseOutlinedIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
            <Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                {/* <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Receipt Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "180%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={getInputValue("date_of_purchase", updatedDateFilter)}
                    onChange={(e) => {
                      onInputChange(
                        "date_of_purchase",
                        e.target.value,
                        setupdatedDateFilter
                      );
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid> */}
                <DualInputProps
                  label="Receipt Date"
                  fromTitle="From"
                  fromOnChange={(data) => {
                    onUpdateFiltedDate(
                      entityConstants.date_of_purchase,
                      "fromDate",
                      data.target.value,
                    );
                  }}
                  fromValue={
                    selectedDates[
                      entityConstants.date_of_purchase
                    ]?.fromDate?.toString() || ""
                  }
                  toTitle="To"
                  toOnChange={(data) => {
                    onUpdateFiltedDate(
                      entityConstants.date_of_purchase,
                      "toDate",
                      data.target.value,
                    );
                  }}
                  toValue={
                    selectedDates[
                      entityConstants.date_of_purchase
                    ]?.toDate?.toString() || ""
                  }
                  type="Date"
                />
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                {/* <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Submitted Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "180%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={getInputValue("createdAt", updatedDateFilter)}
                    onChange={(e) => {
                      onInputChange(
                        "createdAt",
                        e.target.value,
                        setupdatedDateFilter
                      );
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid> */}
                <DualInputProps
                  label="Submitted Date"
                  fromTitle="From"
                  fromOnChange={(data) => {
                    onUpdateFiltedDate(
                      entityConstants.createdAt,
                      "fromDate",
                      data.target.value,
                    );
                  }}
                  fromValue={
                    selectedDates[
                      entityConstants.createdAt
                    ]?.fromDate?.toString() || ""
                  }
                  toTitle="To"
                  toOnChange={(data) => {
                    onUpdateFiltedDate(
                      entityConstants.createdAt,
                      "toDate",
                      data.target.value,
                    );
                  }}
                  toValue={
                    selectedDates[
                      entityConstants.createdAt
                    ]?.toDate?.toString() || ""
                  }
                  type="Date"
                />
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                {/* <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Reviewed Date
                </Typography>
                <Grid display={"flex"} gap={2} mt={2}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "180%",
                    }}
                    type="date"
                    size="small"
                    placeholder="Transaction Date"
                    value={getInputValue("reviewed_date", updatedDateFilter)}
                    onChange={(e) => {
                      onInputChange(
                        "reviewed_date",
                        e.target.value,
                        setupdatedDateFilter
                      );
                    }}
                    InputProps={{
                      inputProps: {
                        max: DateConstants.maxDate,
                      },
                    }}
                  />
                </Grid> */}
                <DualInputProps
                  label="Reviewed Date"
                  fromTitle="From"
                  fromOnChange={(data) => {
                    onUpdateFiltedDate(
                      entityConstants.reviewed_date,
                      "fromDate",
                      data.target.value,
                    );
                  }}
                  fromValue={
                    selectedDates[
                      entityConstants.reviewed_date
                    ]?.fromDate?.toString() || ""
                  }
                  toTitle="To"
                  toOnChange={(data) => {
                    onUpdateFiltedDate(
                      entityConstants.reviewed_date,
                      "toDate",
                      data.target.value,
                    );
                  }}
                  toValue={
                    selectedDates[
                      entityConstants.reviewed_date
                    ]?.toDate?.toString() || ""
                  }
                  type="Date"
                />
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Amount ($)
                </Typography>
                <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    size="small"
                    label="From"
                    value={getAmntInputValue(entityConstants.amount_from)}
                    onChange={(e) =>
                      onInputAmntChange(
                        entityConstants.amount_from,
                        e.target.value,
                      )
                    }
                    // value={inputCompRef.current.amnt_from?.value}
                    // inputRef={(ref)=> (inputCompRef.current.amnt_from= ref)}
                  />
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    size="small"
                    label="To"
                    value={getAmntInputValue(entityConstants.amount_to)}
                    onChange={(e) =>
                      onInputAmntChange(
                        entityConstants.amount_to,
                        e.target.value,
                      )
                    }
                  />
                </Grid>
              </Grid>
              <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                <Typography
                  sx={{
                    fontFamily: theme.font?.fontFamily.primary,
                    fontSize: theme.font?.fontSize.medium,
                    fontWeight: theme.font?.fontWeight.thick,
                  }}
                >
                  Adjusted Amount ($)
                </Typography>
                <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    size="small"
                    label="From"
                    value={getAdjustedAmntInputValue(
                      entityConstants.adjust_from,
                    )}
                    onChange={(e) =>
                      onInputAdjustedAmntChange(
                        entityConstants.adjust_from,
                        e.target.value,
                      )
                    }
                  />
                  <TextField
                    sx={{
                      display: "flex",
                      width: "50%",
                    }}
                    type="text"
                    size="small"
                    label="To"
                    value={getAdjustedAmntInputValue(entityConstants.adjust_to)}
                    onChange={(e) =>
                      onInputAdjustedAmntChange(
                        entityConstants.adjust_to,
                        e.target.value,
                      )
                    }
                  />
                </Grid>
              </Grid>
              <InputProps
                label="Status"
                value={selectedOption}
                type="Select"
                inputPlaceHolder="From"
                onInputChange={(data) => {
                  setSelectedOption(data.target.value);
                }}
                options={dropdownOptions}
              />
              <InputProps
                label="Receipt Type"
                value={selectedReceiptType}
                type="Select"
                inputPlaceHolder="Select Receipt Type"
                onInputChange={(data) => {
                  setSelectedReceiptType(data.target.value);
                }}
                options={receiptTypeOptions}
              />
            </Grid>
          </DialogContent>
          <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
            <Button
              sx={{ ...buttonStyles.outlinedSecondary }}
              onClick={resetFilterState}
            >
              Reset
            </Button>
            <Button
              sx={{ ...buttonStyles.containedSecondary }}
              onClick={handleApplyFilter}
            >
              Apply
            </Button>
          </DialogActions>
        </Grid>
      </Dialog>
      <Grid
        container
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"flex-start"}
        width={"100%"}
        alignItems={"center"}
        sx={{ fontFamily: theme?.font?.fontFamily.primary }}
      >
        <Grid
          borderBottom={theme.border?.newGreyBorder}
          container
          display={"flex"}
          height={"6.25rem"}
          alignItems={"center"}
          justifyContent={"space-between"}
          px={4}
        >
          <Grid item lg={2}>
            <Typography
              sx={{
                fontFamily: theme.font?.fontFamily.primary,
                fontWeight: theme.font?.fontWeight.thick,
                fontSize: theme.font?.fontSize.large,
              }}
            >
              Receipts
            </Typography>
          </Grid>

          <Grid
            item
            container
            lg={10}
            px={2}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "",
            }}
            gap={2}
          >
            <ExportDialog
              closeDialog={setOpen}
              emailSent={emailSent}
              exportTitle="Receipt"
              handleClose={handleClose}
              open={open}
              sending={sending}
              handleSendExport={handleSendExport}
            />
            {getAuditTrailPermission("read") && displayAuditTrails()}

            {getFraudDetectPermission("read") && (
              <CommonButton
                buttonTitle="Fraud Detect Configuration"
                variant="text"
                color="secondary"
                onClick={() => setOpenFraudSettings(true)}
              />
            )}

            {getReceiptPermission("create") && (
              <CommonButton
                buttonTitle=" Add Receipt"
                variant="contained"
                color="secondary"
                onClick={() => setOpenAddReceipt(true)}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Drawer
          anchor={"right"}
          open={openUpdateReceipt}
          onClose={() => {
            setOpenUpdateReceipt(false);
            navigate("/receipts");
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"920px"} height={"100%"}>
            <UpdateMemberReceipts
              onRefresh={() => {
                handleReset();
                setIsApiCall(true);
              }}
              receipt={receipt}
              closeDrawer={closeDrawer}
              module="receipts"
            />
          </Grid>
        </Drawer>
        <Drawer
          anchor={"right"}
          open={openAddReceipt}
          onClose={() => {
            setOpenAddReceipt(false);
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"642px"} height={"100%"}>
            <AddReceipt closeDrawer={setOpenAddReceipt} refreshApi={onBind} />
          </Grid>
        </Drawer>
        <Drawer
          anchor={"right"}
          open={openFraudSettings}
          onClose={() => {
            setOpenFraudSettings(false);
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px 0 0 16px",
            },
          }}
        >
          <Grid width={"782px"} height={"100%"}>
            <FraudDetectSettings closeDrawer={setOpenFraudSettings} />
          </Grid>
        </Drawer>
        <Grid
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          px={4}
          pl={2}
          py={3}
        >
          {getReceiptPermission("export") && (
            <CommonButton
              buttonTitle="Export"
              variant="text"
              color="secondary"
              onClick={handleExport}
              disabled={!data.length}
            />
          )}
          {!isRandomAudit && (
            <Grid display={"flex"} gap={3}>
              {getReceiptPermission("read") && (
                <SearchInput
                  HelpTip={SearchToolTip.Receipts}
                  onCallBack={handleSearch}
                  ref={searchInputRef}
                />
              )}
              {getReceiptPermission("read") && (
                <Button
                  variant="text"
                  startIcon={
                    filterActive ? (
                      <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                    ) : (
                      <FilterAltOutlinedIcon />
                    )
                  }
                  sx={{
                    color: theme.color?.newFilterGrey,
                    textTransform: "capitalize",
                  }}
                  onClick={() => setOpenFilter(true)}
                >
                  Filter
                </Button>
              )}
            </Grid>
          )}
        </Grid>

        <Grid container width={"100%"} px={2} mt={2}>
          {getReceiptPermission("read") && (
            <InfiniteTable
              header={columns}
              contentItems={!isRandomAudit ? data : randomData}
              fetchMoreData={() => {
                // Previous code
                // let flag = Number(totalDataCount) > 50;

                // if (flag) {
                //   onBind(flag);
                // }
                if (!isRandomAudit) {
                  onBind(true);
                }
              }}
              hasMoreRecords={nextPageKey !== null}
              metaData={metaData}
              isRandomAudit={isRandomAudit}
              isInitialLoading={
                (!isRandomAudit
                  ? data.length === 0
                  : randomData.length === 0) &&
                (isApiCall || loadingAPI)
              }
              totalRecords={totalDataCount}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ListReceipt;
